var React = require('react');

function ShareFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 0H0V40H40V0ZM17.7153 28.2051H21.353V20.456H23.7805L24.1026 17.4699H21.353L21.3575 15.9768C21.3575 15.1979 21.433 14.781 22.5685 14.781H24.0853V11.7949H21.6578C18.7417 11.7949 17.7153 13.2442 17.7153 15.6785V17.4699H15.8974V20.456H17.7153V28.2051Z","fill":"currentColor"}));
}

ShareFacebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = ShareFacebook;

ShareFacebook.default = ShareFacebook;
